import {ResearchLitElement, html, css} from '@core/research-lit-element';

export class ResearchCardSkeleton extends ResearchLitElement {
    static get is() {
        return 'research-card-skeleton';
    }
    static get styles() {
        return css`
            :host {
                display: flex;
                flex-direction: column;
                width: 100%;
                --opacity: 0.1;
                background-color: var(--color-invert-background-solid-10);
            }

            .container {
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                width: 100%;
                height: 360px;
                border-radius: var(--border-radius-31);
                padding: var(--space-40) var(--space-48) var(--space-24);
                box-sizing: border-box;
                border: 1px solid var(--color-invert-component-tr-10);
                background-color: var(--color-invert-component-tr-80);
            }


            .header {
                display: flex;
                justify-content: space-between;
                gap: var(--space-16);
            }

            .title {
                height: 30px;
                width: 60%;
                background-color: var(--color-invert-component-tr-70);
                border-radius: var(--border-radius-31);
            }

            .chips-wrapper {
                margin-top: var(--space-8);
                display: flex;
                gap: var(--space-16);
            }
          
            .chips {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 30px;
                width: 113px;
                background-color: var(--color-invert-component-tr-80);
                border-radius: 100px;
                box-sizing: border-box;
            }

            .item {
                height: 44px;
                background-color: var(--color-invert-component-tr-70);
                border-radius: var(--border-radius-31);
            }
          
            .additional-container {
              display: flex;
              justify-content: flex-end;
              gap: var(--space-16);
            }

            .text {
                display: flex;
                height: 40px;
                width: 107px;
                background-color: var(--color-invert-component-tr-80);
                border-radius: var(--border-radius-30);
            }
    
            .button {
                display: flex;
                height: 40px;
                width: 144px;
                background-color: var(--color-invert-component-tr-80);
                border-radius: var(--border-radius-30);
            }

            @media (max-width: 600px) {
              :host {
                border-radius: var(--border-radius-36);
              }
              
              .container {
                border-radius: var(--border-radius-36);
                padding: var(--space-24);
              }
              
              .header > .chips {
                display: none;
              }

              .chips-wrapper {
                flex-wrap: wrap;
              }
            }
        `;
    }

    render() {
        return html`
            <div class="container">
                <div  class="header">
                    <div class="title"></div>
                    <div class="chips"></div>
                </div>
                <div class="chips-wrapper">
                    <div class="chips"></div>
                    <div class="chips"></div>
                    <div class="chips"></div>
                </div>
                
                <div class="item" style="width: 60%"></div>
                <div class="item" style="width: 250px"></div>
                <div class="additional-container">
                    <div class="text"></div>
                    <div class="button"></div>
                </div>
            </div>
        `;
    }
}
customElements.define(ResearchCardSkeleton.is, ResearchCardSkeleton);
